import excelIcon from '@/assets/images/download-format/excel.png'
import pdfIcon from '@/assets/images/download-format/pdf.png'

const formatTypes = [
  { label: 'Excel', type: 'excel', icon: excelIcon },
  { label: 'PDF', type: 'pdf', icon: pdfIcon },
]

export default formatTypes
